// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A-mE4","langSwitcherWrapper":"styles_langSwitcherWrapper__nEx96"};